import React from 'react';
import { List } from 'immutable';
import YoutubeVideoResourceRecord from '../../data/YoutubeVideoResourceRecord';
import YoutubeVideoListItem from './YoutubeVideoListItem';
import './YoutubePlaylist.pcss';

interface YoutubePlaylistProps {
  videos: List<YoutubeVideoResourceRecord>;
  activeVideoId: string | null;
  onVideoClick: (videoId) => void;
}

const YoutubePlaylist: React.FC<YoutubePlaylistProps> = ({
  videos,
  onVideoClick,
  activeVideoId,
}) => {
  return (
    <div className="YoutubePlaylist">
      {videos.map((video) => (
        <YoutubeVideoListItem
          key={video.getVideoId()}
          video={video}
          onClick={onVideoClick}
          isActive={activeVideoId === video.getVideoId()}
        />
      ))}
    </div>
  );
};

export default YoutubePlaylist;
